import React, {useEffect, useState} from "react";
import {
  ProductListFilterItemBoolean,
  ProductListFilterItemSelect,
  ProductListFilterItemType,
} from "../../../typescript-library";
import {useProductListContext} from "../productListProvider/ProductListProvider";
import {useTranslation} from "react-i18next";
import ToggleSwitch from "../../atoms/ToggleSwitch";

type ProductFilterBooleanProps = {
  item: ProductListFilterItemBoolean | ProductListFilterItemSelect;
  onSelect?: (value: boolean | string[]) => void;
};

const ProductFilterBoolean: React.FC<ProductFilterBooleanProps> = ({item, onSelect}) => {
  const {t} = useTranslation();
  const {state, dispatch} = useProductListContext();
  const [isSelected, setIsSelected] = useState<boolean>(false);

  useEffect(() => {
    setIsSelected(!!state.filters[item.field]);
  }, [state.filters[item.field]]);

  const count = isBooleanFilter(item)
    ? item.values.get(ProductListFilterItemBoolean.trueValueId)?.count ?? 0
    : item.values.get("-1")?.count ?? 0;
  if (!count) {
    return null;
  }

  const toggleFilter = (checked: boolean) => {
    setIsSelected(checked);
    const isBoolean = isBooleanFilter(item);
    if (onSelect) {
      onSelect(isBoolean ? checked : checked ? ["-1"] : []);

      return;
    }
    if (checked) {
      dispatch({type: "SET_FILTER", payload: {field: item.field, value: isBoolean || ["-1"]}});
    } else {
      dispatch({type: "REMOVE_FILTER", payload: {field: item.field}});
    }
  };

  return (
    <div className="filter-item filter-item__boolean">
      <ToggleSwitch onChange={toggleFilter} checked={isSelected} disabled={!count}>
        <span className="filter-item__boolean__title" title={`${item.name || t(`product.${item.field}`)}`}>
          {`${item.name || t(`product.${item.field === "availability" ? "inStock" : item.field}`)}`}
        </span>
        <span className="filter-item__count">({count})</span>
      </ToggleSwitch>
    </div>
  );
};

export default ProductFilterBoolean;

function isBooleanFilter(
  filter: ProductListFilterItemBoolean | ProductListFilterItemSelect,
): filter is ProductListFilterItemBoolean {
  return filter.type === ProductListFilterItemType.boolean;
}
